import {Cell} from "react-table";
import React from "react";

/**
 * Rendert die "Veranstaltung"-Tabellen-Zelle für das Einreichungslisting
 *
 * @param cell
 * @constructor
 */
const EventNameColumn: (cell: Cell) => JSX.Element = (cell: Cell) => {
    return (
        <span>{cell.row.values.event.name}</span>
    );
}

export default EventNameColumn;